import {Scheduler} from './Scheduler';
import {elementInViewport} from './functions';

import 'slick-carousel';

function getBodyScrollTop() {
    const el = document.scrollingElement || document.documentElement;

    return el.scrollTop;
}

var MainSlider = {
    $slideTitles: null,
    $sliderImage: null,
    i: 1,
    defaultDuration: 5000,
    hoverTimeout: null,

    init: function() {
        var $holder = $('.main-slider'),
            duration = $holder.data('duration'),
            that = this;

        this.$slideTitles = $holder.find('.slide-title');
        this.$sliderImage = $holder.find('.slider-image');

        if (duration === '' || duration <= 0) {
            duration = this.defaultDuration;
        }
        this.defaultDuration = duration;

        Scheduler.add(function() {
            that.$slideTitles
                .find('.slide-progress-bar')
                .css({'animation-duration': duration + 'ms'});
            that.showSlide(0);
            that.runInterval(duration);
        }, null, 5000);

        //this.initHoverEvent(duration);
    },
    initHoverEvent: function(duration) {
        var that = this;

        this.$slideTitles.find('.slide-title-item').on({
            mouseover: function(e) {
                var $this = $(this);

                that.hoverTimeout = setTimeout(function() {
                    var $sTitle = $this.closest('.slide-title'),
                        selectedIndex;

                    if ($sTitle.hasClass('active')) {
                        return;
                    }
                    selectedIndex = parseInt($sTitle.index());

                    e.preventDefault();

                    that.hideSlides();
                    that.showSlide(selectedIndex);
                    that.i = selectedIndex + 1;
                    if (that.$slideTitles.length === that.i) {
                        that.i = 0;
                    }

                    that.runInterval(duration);
                }, 200);
            },
            mouseleave: function() {
                clearTimeout(that.hoverTimeout);
            }
        });
    },
    showSlide: function(i) {
        MainSlider.$slideTitles
            .eq(i)
            .addClass('active')
            .find('.slide-description')
            .slideDown(400);
    },
    hideSlides: function() {
        MainSlider.$slideTitles
            .removeClass('active')
            .find('.slide-description')
            .slideUp(400);
    },
    runInterval: function(duration) {
        if (document.hidden || document.msHidden || document.webkitHidden || document.mozHidden) {
            duration = 50;
        }
        Scheduler.add(function() {
            if (!(document.hidden || document.msHidden || document.webkitHidden || document.mozHidden)) {
                this.interval();
            }
            this.runInterval(this.defaultDuration);
        }, this, duration);
    },
    interval: function() {
        MainSlider.hideSlides();
        MainSlider.showSlide(MainSlider.i);

        MainSlider.i++;
        if (MainSlider.$slideTitles.length === MainSlider.i) {
            MainSlider.i = 0;
        }
    }
};

var ScrollFixedSlider = {
    $holder: null,
    $progress: null,
    $steps: null,
    scrollTimeout: null,
    interval: true,
    stopAnimation: false,
    intervalDuration: 15000,
    intervalActive: -1,

    init: function() {
        var $holder = $('.scroll-fixed-slider'),
            $steps = $holder.find('.slider-steps .step'),
            that = this;

        this.$holder = $holder;
        this.$steps = $steps;
        this.$progress = $holder.find('.progress');

        $holder.attr('data-aos', 'scroll-fixed-slide')
            .attr('data-aos-id', 'scroll-fixed-slide')
            .attr('data-aos-offset', '500');

        $(document).one('aos:in:scroll-fixed-slide', function() {
            that.autoSlide();
            that.checkVisible();
        });

        if ($holder.length > 0) {
            this.initClickEvent($steps.length);
            this.initLazyLoadEvent();
            this.resizeContent();
        }
    },
    autoSlide: function() {
        let stepsLength = this.$steps.length;

        this.intervalActive++;
        if (this.intervalActive === stepsLength) {
            return;
        }
        if (!this.stopAnimation) {
            this.resumeAutoSlide();
        }
        this.changeSlide(
            this,
            this.$holder.find('.slide'),
            this.intervalActive
        );
    },
    initClickEvent: function(stepsLength) {
        let that = this;

        this.$steps.on('click', function(e) {
            let $this = $(this),
                $slides = that.$holder.find('.slide'),
                currentStep = $this.index(),
                progress = (currentStep + 1) / stepsLength,
                progressBarWidth = progress * 100;

            that.stopAnimation = true;
            that.pauseAutoSlide();

            e.preventDefault();

            that.$progress.velocity('stop').velocity({'width': progressBarWidth + '%'}, {duration: 200});
            that.changeSlide(that, $slides, currentStep);
        });
    },
    changeSlide: function(that, $slides, currentStep) {
        that.$steps.removeClass('active seen');
        that.$steps.eq(currentStep).addClass('active');

        for (let i = 0; i < currentStep; i++) {
            that.$steps.eq(i).addClass('seen');
        }

        $slides.removeClass('active');
        $slides.eq(currentStep).addClass('active').find('.slide-video').trigger('slide:show');

        ScrollFixedSlider.resizeContent();
    },
    resizeContent() {
        var $slides = this.$holder.find('.slider-slides'),
            $activeSlide = this.$holder.find('.slide.active'),
            height = $activeSlide.outerHeight();

        $slides.velocity('stop').velocity({'height': height + 50}, 400);
    },
    initLazyLoadEvent() {
        $(window).on('lazyloaded', () => {
            this.resizeContent();
        });
    },
    checkVisible() {
        if (!this.stopAnimation) {
            if (!elementInViewport(this.$progress) && this.interval) {
                this.pauseAutoSlide();
            } else if (elementInViewport(this.$progress) && !this.interval) {
                this.resumeAutoSlide();
            }
            Scheduler.add(this.checkVisible, this, 500);
        }
    },
    pauseAutoSlide() {
        this.interval = false;
        this.$progress.velocity('stop');
    },
    resumeAutoSlide() {
        let that = this,
            stepsLength = this.$steps.length,
            targetWidth = (this.intervalActive + 1) / stepsLength,
            width = parseInt(this.$progress.css('width')),
            progressContainerWidth = parseInt(this.$holder.find('.progress-container').css('width')),
            stepPercent = 1 / stepsLength,
            actualPercent = width / progressContainerWidth,
            remainedPercent = (stepPercent * (this.intervalActive + 1) - actualPercent) / stepPercent;

        this.interval = true;

        this.$progress.velocity('stop').velocity(
            {'width': targetWidth * 100 + '%'},
            {
                duration: this.intervalDuration * remainedPercent,
                complete: function() {
                    if (that.interval) {
                        that.autoSlide();
                    }
                }
            },
        );
    }
};

class CardSlider
{
    constructor($holder) {
        this.$holder = $holder;
        this.$slidesContainer = $holder.find('.slides');
        this.$slides = this.$slidesContainer.find('.slide');
        this.defaultDuration = 5000;
        this.duration = null;
        this.freeze = false;
        this.slideWidth = this.$slides
            .first()
            .outerWidth(true);
    }

    run() {
        this.duration = this.getDuration();

        this.nextSlide();
        this.runInterval();
        this.initResizeEvent();
        this.initPaginationEvents();
        this.initSwipeEvents();
    }

    runInterval() {
        Scheduler.remove(this.interval, this);
        Scheduler.add(this.interval, this, this.duration);
    }

    interval() {
        if (!(document.hidden || document.msHidden || document.webkitHidden || document.mozHidden)) {
            this.nextSlide();
        }
        this.runInterval();
    }

    getDuration() {
        var duration = this.$holder.data('duration');

        if (duration === undefined || duration <= 0 || duration === '') {
            duration = this.defaultDuration;
        }

        return duration;
    }

    initPaginationEvents() {
        var $paginationHolder = this.$holder.find('.slider-pagination');

        $paginationHolder.find('.next-slide').on('click', e => {
            e.preventDefault();

            if (!this.freeze) {
                this.runInterval();
                this.nextSlide();
            }
        });

        $paginationHolder.find('.prev-slide').on('click', e => {
            e.preventDefault();

            if (!this.freeze) {
                this.runInterval();
                this.prevSlide();
            }
        });
    }

    initSwipeEvents() {
        $(document).on({
            'swiped-left': (e) => {
                var $sliderHolder = $(e.target).closest('.slides');

                if ($sliderHolder.length > 0) {
                    this.runInterval();
                    this.nextSlide();
                }
            },
            'swiped-right': (e) => {
                var $sliderHolder = $(e.target).closest('.slides');

                if ($sliderHolder.length > 0) {
                    this.runInterval();
                    this.prevSlide();
                }
            }
        });
    }

    initResizeEvent() {
        $(window).on('resize', () => {
            this.$slides = this.$slidesContainer.find('.slide');
            this.slideWidth = this.$slides
                .first()
                .outerWidth(true);
        });
    }

    prevSlide() {
        var $slides = this.$slidesContainer.find('.slide');

        this.beforePrevSlide($slides);

        this.$slidesContainer.animate({
            'margin-left': this.slideWidth
        }, 500, () => {
            this.afterPrevSlide($slides);
            this.$slidesContainer.css({'margin-left': 0});
        });
    }

    nextSlide() {
        var $slides = this.$slidesContainer.find('.slide');

        this.beforeNextSlide($slides);

        this.$slidesContainer.animate({
            'margin-left': '-' + this.slideWidth
        }, 500, () => {
            this.afterNextSlide($slides);
            this.$slidesContainer.css({'margin-left': 0});
        });
    }

    beforePrevSlide($slides) {
        this.freeze = true;
        $slides.removeClass('active').addClass('movingRight');
    }

    afterPrevSlide($slides) {
        this.freeze = false;
        $slides.last().hide(0).prependTo(this.$slidesContainer).fadeIn(300);
        this.$slidesContainer.css({'margin-left': 0});
        $slides.removeClass('movingRight');
    }

    beforeNextSlide($slides) {
        this.freeze = true;
        $slides.removeClass('active').addClass('movingLeft');
    }

    afterNextSlide($slides) {
        this.freeze = false;
        $slides.first().hide(0).appendTo(this.$slidesContainer).fadeIn(300);
        this.$slidesContainer.css({'margin-left': 0});
        $slides.removeClass('movingLeft');
    }
}

class CardCenterSlider extends CardSlider
{
    constructor($holder) {
        super($holder);
        this.centerSlide = Math.floor(this.$slides.length / 2);
    }

    beforePrevSlide($slides) {
        super.beforePrevSlide($slides);
        $slides.eq(this.centerSlide - 1).addClass('active');
    }

    beforeNextSlide($slides) {
        super.beforeNextSlide($slides);
        $slides.eq(this.centerSlide + 1).addClass('active');
    }
}

class CardSideSlider extends CardSlider
{
    constructor($holder) {
        super($holder);
    }

    beforeNextSlide($slides) {
        super.beforeNextSlide($slides);
        $slides.eq(1).addClass('active');
    }
}

class ScrollLine
{
    constructor($holder) {
        this.$holder = $holder;
        this.$progressBar = $holder.find('.progress-bar');
    }

    run() {
        if (this.$holder.length > 0) {
            this.initScrollEvent();
            this.initShowMoreClickEvent();
        }
    }

    initShowMoreClickEvent() {
        let that = this;

        this.$holder.find('.show-more').on('click', function(e) {
            let $button = $(this),
                $item = $button.parents('.scroll-line-item');

            e.preventDefault();

            $item.addClass('expanded');
            $button.remove();

            Scheduler.add(that.updateLine, that, 400);
        });
    }

    initScrollEvent() {
        $(window).on('scroll', () => {
            this.updateLine();
        });
    }

    updateLine() {
        let st = getBodyScrollTop(),
            $items = this.$holder.find('.scroll-line-item'),
            progressBarOffset = this.$progressBar.offset(),
            progressBarHeight = 0,
            windowHeight = $(window).height(),
            progressBarLength = (st - progressBarOffset.top + (windowHeight / 2));

        $items.filter(':not(:last-child)').each((i, item) => {
            progressBarHeight += $(item).outerHeight();
        });

        if (progressBarLength > progressBarHeight) {
            progressBarLength = progressBarHeight;
        }

        this.$progressBar.css({'height': progressBarLength});

        $items.each(function() {
            let $item = $(this);

            if ($item.offset().top < progressBarLength + progressBarOffset.top - 15) {
                $item.addClass('highlight');
            } else {
                $item.removeClass('highlight');
            }
        });
    }
}

class LogoSlider
{
    constructor($holder) {
        this.$holder = $holder;
    }

    run() {
        if (this.$holder.length > 0) {
            this.initSlider();
        }
    }

    initSlider() {
        this.$holder.slick({
            lazyLoad: 'ondemand',
            slidesToShow: 6,
            draggable: false,
            touchMove: true,
            swipeToSlide: true,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2500,
            arrows: false,
            dots: false,
            pauseOnHover: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4
                    }
                }, {
                    breakpoint: 520,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });
    }
}

class TechnologyLogo extends LogoSlider
{
    initSlider() {
        this.$holder.slick({
            lazyLoad: 'ondemand',
            slidesToShow: 8,
            draggable: false,
            touchMove: true,
            swipeToSlide: true,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2500,
            arrows: false,
            dots: false,
            pauseOnHover: false,
            adaptiveHeight: true,
            centerMode: true,
            infinite: true,
            variableWidth: true,
        });
    }
}

$(function() {
    MainSlider.init();
    (new LogoSlider($('.clients'))).run();
    (new TechnologyLogo($('.technology-icons'))).run();
    Scheduler.add(function() {
        ScrollFixedSlider.init();
        (new CardCenterSlider($('.card-center-slider'))).run();
        (new ScrollLine($('.scroll-line-section'))).run();
        (new ScrollLine($('.scroll-line-steps-section'))).run();
    }, null, 500);
});
